var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.32812H12.75V5.82812C12.75 3.75813 11.07 2.07812 9 2.07812C6.93 2.07812 5.25 3.75813 5.25 5.82812V7.32812H4.5C3.675 7.32812 3 8.00313 3 8.82812V16.3281C3 17.1531 3.675 17.8281 4.5 17.8281H13.5C14.325 17.8281 15 17.1531 15 16.3281V8.82812C15 8.00313 14.325 7.32812 13.5 7.32812ZM9 14.0781C8.175 14.0781 7.5 13.4031 7.5 12.5781C7.5 11.7531 8.175 11.0781 9 11.0781C9.825 11.0781 10.5 11.7531 10.5 12.5781C10.5 13.4031 9.825 14.0781 9 14.0781ZM11.325 7.32812H6.675V5.82812C6.675 4.54562 7.7175 3.50313 9 3.50313C10.2825 3.50313 11.325 4.54562 11.325 5.82812V7.32812Z",
    fill: "#8596B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.9f96c21f56b5d9abf0268b6cf54a9d8d.svg";
export { ForwardRef as ReactComponent };